<script>
  import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Form,
    FormGroup,
    Label,
    Button,
  } from 'sveltestrap'
  import SkeletonElement from '../Components/SkeletonElement.svelte'
</script>

<div class="page-content skeleton">
  <Container fluid>
    <!-- Breadcrumb Skeleton -->
    <div style="margin-bottom:20px;">
      <SkeletonElement width="30%" height="20px" />
    </div>

    <!-- Fila de resumen: WelcomeComp, MonthlyEarning y Tarjeta de alertas -->
    <Row style="margin-bottom: 20px;">
      <!-- WelcomeComp skeleton -->
      <Col xl="3">
        <Card style="height: 93%;">
          <CardBody>
            <SkeletonElement
              width="70%"
              height="20px"
              styleCustom="margin-bottom:10px;"
            />
            <SkeletonElement width="50%" height="15px" />
            <div style="margin:20px auto; width:100px; height:100px;">
              <SkeletonElement width="100%" height="100%" />
            </div>
            <SkeletonElement
              width="80%"
              height="20px"
              styleCustom="margin-top:10px;"
            />
            <SkeletonElement
              width="60%"
              height="15px"
              styleCustom="margin-top:5px;"
            />
          </CardBody>
        </Card>
      </Col>
      <!-- MonthlyEarning skeleton -->
      <Col xl="4">
        <Card style="height: 93%;">
          <CardBody>
            <SkeletonElement
              width="100%"
              height="30px"
              styleCustom="margin-bottom:10px;"
            />
            <SkeletonElement
              width="80%"
              height="50px"
              styleCustom="margin-bottom:10px;"
            />
            <SkeletonElement width="100%" height="20px" />
          </CardBody>
        </Card>
      </Col>
      <!-- Tarjeta de alertas skeleton -->
      <Col xl="5">
        <Card class="mini-stats-wid" style="height: 93%;">
          <CardBody>
            <Row>
              <Col md="6">
                <Card class="h-100">
                  <div style="padding:16px;">
                    <SkeletonElement
                      width="60%"
                      height="20px"
                      styleCustom="margin-bottom:10px;"
                    />
                    <SkeletonElement
                      width="40%"
                      height="20px"
                      styleCustom="margin-bottom:10px;"
                    />
                    {#each Array(5) as _}
                      <SkeletonElement
                        width="90%"
                        height="15px"
                        styleCustom="margin-bottom:5px;"
                      />
                    {/each}
                  </div>
                </Card>
              </Col>
              <Col md="6">
                <Card class="h-100">
                  <div style="padding:16px;">
                    <SkeletonElement
                      width="80%"
                      height="30px"
                      styleCustom="margin-bottom:10px;"
                    />
                    <SkeletonElement width="70%" height="15px" />
                  </div>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>

    <!-- Sección de filtros y tabla skeleton -->
    <Row>
      <Col lg="12">
        <SkeletonElement
          width="40%"
          height="20px"
          styleCustom="margin-bottom:20px;"
        />
        <Form>
          <Row>
            <Col sm="6" class="col-xl">
              <FormGroup class="mt-3 mb-0">
                <SkeletonElement width="100%" height="30px" />
              </FormGroup>
            </Col>
            <Col sm="6" class="col-xl">
              <FormGroup class="mt-3 mb-0">
                <SkeletonElement width="100%" height="30px" />
              </FormGroup>
            </Col>
            <Col sm="6" class="col-xl">
              <FormGroup class="mt-3 mb-0">
                <SkeletonElement width="100%" height="30px" />
              </FormGroup>
            </Col>
            <Col sm="6" class="col-xl align-self-end">
              <div class="mb-3 text-end">
                <SkeletonElement width="120px" height="35px" />
              </div>
            </Col>
          </Row>
        </Form>
        <!-- Tabla skeleton -->
        <Card style="margin-top:20px;">
          <CardBody>
            <SkeletonElement
              width="100%"
              height="20px"
              styleCustom="margin-bottom:15px;"
            />
            <div class="table-responsive">
              <table class="table align-middle table-nowrap mb-0">
                <thead class="table-light">
                  <tr>
                    {#each Array(15) as _, i}
                      <th><SkeletonElement width="80%" height="15px" /></th>
                    {/each}
                  </tr>
                </thead>
                <tbody>
                  {#each Array(1) as _}
                    <tr>
                      {#each Array(15) as _}
                        <td><SkeletonElement width="80%" height="15px" /></td>
                      {/each}
                    </tr>
                  {/each}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>

        <!-- Mapa skeleton -->
        <div id="map" style="height:500px;">
          <SkeletonElement width="100%" height="500px" />
        </div>
      </Col>
    </Row>

    <!-- Última fila: LatestTransactions skeleton -->
    <Row>
      <Col lg="12">
        <SkeletonElement
          width="100%"
          height="150px"
          styleCustom="margin-top:20px;"
        />
      </Col>
    </Row>
  </Container>
</div>

<style>
  .skeleton {
    opacity: 0.8;
  }
</style>
